<app-tooltip [message]="'offers.list.is-main-source-transaction' | translate : { source: transactionSource }" position="left">
    <i class="i i-main-source"></i>
</app-tooltip>
